/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/no-commonjs,
  import/no-extraneous-dependencies,
  max-len,
  react/no-string-refs,
  react/prop-types
*/
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import Header from 'signer/components/common/header';
import Logo from 'signer/components/common/logo';
import Button from 'common/components/button';
import HfReactHelper from 'common/utils/hf-react-helper';
import HeaderAlert from 'signer/components/common/header-alert';
import HeaderAlertTypes from 'signer/components/common/header-alert/header-alert-types';
import createReactClass from 'create-react-class';

require('./index.scss');


const messages = defineMessages({
  labelText: {
    id: 'common.continueButton.labelText',
    description: 'button text when clicked redirects to new page',
    defaultMessage: 'Continue',
  },
  checkingText: {
    id: 'signer.enterCode.checkingText',
    description: 'text in signer flow, checking if the access code provided is valid',
    defaultMessage: 'Checking...',
  },
});

// FIXME: change to AccessCode
const AccessCode = createReactClass({

  propTypes: {
    numAttemptsLeft: PropTypes.number,
    callback: PropTypes.func,
  },

  getInitialState() {
    return {
      checkFailed: false,
      numAttemptsLeft: this.props.numAttemptsLeft,
      buttonText: this.props.intl.formatMessage(messages.labelText),
    };
  },

  /**
    */

  onSubmitCode(evt) {

    evt.preventDefault();

    const code = HfReactHelper.trim(this.refs.code.value);
    if (code) {

      this.setState({
        checkFailed: false,
        buttonText: this.props.intl.formatMessage(messages.checkingText),
      });

      this.props.app.signatureRequest
        .authorize(code)
        .then(() => {

          this.setState({
            checkFailed: false,
            numAttemptsLeft: null,
            buttonText: this.props.intl.formatMessage(messages.labelText),
          });

          if (this.props.callback) {
            this.props.callback();
          }
        })
        .catch((error) => {
          this.setState({
            checkFailed: true,
            numAttemptsLeft: error.data ? error.data.numAttemptsLeft : null,
            buttonText: this.props.intl.formatMessage(messages.labelText),
          });
        });
    }
  },

  /**
    */

  render() {

    let alert;
    let alertMessage;
    const outOfAttempts = (this.state.numAttemptsLeft === 0);
    const showAlert = (this.state.checkFailed || outOfAttempts);

    if (showAlert) {
      alertMessage = outOfAttempts
        ? <FormattedMessage
          id="signer.enterCode.error.maxAttemptsText"
          description="error message in signer flow, informing singer have maxed out the attemps to put access code"
          defaultMessage="You have reached the maximum number of attempts." />
        : <FormattedMessage
          id="signer.enterCode.error.incorrectText"
          description="text in signer flow, informing signer that the access code is not correct"
          defaultMessage="The access code you've entered is incorrect. {attemptsRemaining} {attemptsRemaining, plural, =1 {attempt} other {attempts}} remaining."
          values={{ attemptsRemaining: this.state.numAttemptsLeft }} />;

      alert = (
        <HeaderAlert
          type={HeaderAlertTypes.ERROR}
                    // 'icon'          : PropTypes.string,
          message={alertMessage}
          shouldTimeout={false} />
      );
    }

    return (
      <div className='m-signer-mobile-access-code'>
        <Header {...this.props} className='whitelabel-header'>
          <Logo className='logo' {...this.props} />
        </Header>
        { alert }
        <form className='m-signer-mobile-access-code--form' onSubmit={this.onSubmitCode} >
          <label className='m-signer-mobile-access-code--form-title'>
            <FormattedMessage
              id="signer.enterCode.title"
              description="title text in signer flow, asking signer to input access code"
              defaultMessage="Please enter access code to view" />
          </label>
          <input type='text' ref='code'></input>
          <div className='m-signer-mobile-access-code--form-note'>
            <FormattedMessage
              id="signer.enterCode.note"
              description="text in singer flow, notifying signer access code field is case sensitive and to put exactly as they received"
              defaultMessage="Note: the access code is case sensitive." />
          </div>
          <Button buttonText={this.state.buttonText} disabled={outOfAttempts} className='whitelabel-primary-button' type='submit' />
        </form>

      </div>
    );
  },
});

module.exports = injectIntl(AccessCode);
